// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_dm-0";
export var headerCellHover = "_dm-1";